import { render, staticRenderFns } from "./reportDetailMore.vue?vue&type=template&id=24062baa&scoped=true"
import script from "./reportDetailMore.vue?vue&type=script&lang=js"
export * from "./reportDetailMore.vue?vue&type=script&lang=js"
import style0 from "./reportDetailMore.vue?vue&type=style&index=0&id=24062baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24062baa",
  null
  
)

export default component.exports